export default "__VITE_ASSET__DuHQ9UxV__"